import clsx from 'clsx';
import { getRiskScoreColor, getRiskScoreBarColor } from '@/utils/format';
import type { RiskCategory } from '@/types';

interface ConcentrationRiskScoreProps {
  score: number;
  category: RiskCategory;
  size?: 'sm' | 'md' | 'lg';
}

const CATEGORY_LABELS: Record<RiskCategory, string> = {
  low: 'LOW RISK',
  moderate: 'MODERATE',
  high: 'HIGH RISK',
  critical: 'CRITICAL',
};

export function ConcentrationRiskScore({
  score,
  category,
  size = 'md',
}: ConcentrationRiskScoreProps) {
  const sizeClasses = {
    sm: { number: 'text-lg', label: 'text-[9px]', bar: 'h-1', width: 'w-16' },
    md: { number: 'text-3xl', label: 'text-xs', bar: 'h-2', width: 'w-full' },
    lg: { number: 'text-5xl', label: 'text-sm', bar: 'h-3', width: 'w-full' },
  };
  const s = sizeClasses[size];

  return (
    <div className={clsx('flex flex-col items-center gap-1', s.width)}>
      <span className={clsx(s.number, 'font-bold tracking-tighter', getRiskScoreColor(score))}>
        {Math.round(score)}
      </span>
      <div className={clsx('w-full bg-mono-800 rounded-full overflow-hidden', s.width)}>
        <div
          className={clsx(s.bar, 'rounded-full transition-all', getRiskScoreBarColor(score))}
          style={{ width: `${Math.min(score, 100)}%` }}
        />
      </div>
      <span className={clsx(s.label, 'tracking-widest text-mono-500')}>
        {CATEGORY_LABELS[category]}
      </span>
    </div>
  );
}
